import { logger } from "./logger";

/**
 * 前端事故埋点(ADV-LOCK-1,2026-08-18 老板拍板加)。
 *
 * ★为什么要它:老板那一枪「输入框永久锁死」的取证只能靠推理 —— 后端 resume 200/38~125ms
 * 干净返回,浏览器侧**零痕迹**,无法直接证明「回包没到」。下次再发生时,这条埋点就是证据。
 *
 * ★只带技术字段,**绝不带用户内容/客户数据**:类型是封闭的(不给自由 payload 口),
 * 想加字段必须改这里并想清楚它会不会捎带业务文本。
 *
 * ★上报口:仓里目前没有前端上报后端接口(logger 里那处 PROD 分支是 placeholder),
 * 按老板「别为此新造后端接口」的口径,落 logger.error(console.error 结构化字段,
 * e2e 可 page.on("console") 断言)+ 进程内环形缓冲(单测断言埋点真被调用)。
 */
export interface FrontendIncident {
  /** 事故类型(闭集):请求超时 / 锁态看门狗强解 */
  event: "request_timeout" | "chat_lock_watchdog";
  /** 接口路径(不含 query,query 可能带业务参数) */
  path: string;
  /** 从发起到判定的毫秒数 */
  elapsedMs: number;
  /** 本次请求的 X-Trace-ID(有则带,便于和后端日志对齐) */
  traceId?: string;
  /** 会话 id(军师会话锚点,非用户内容) */
  sessionId?: string;
}

/** 环形缓冲上限:埋点是排查用的近期痕迹,不是日志系统,别把内存吃了。 */
const MAX_KEPT = 20;
const recent: FrontendIncident[] = [];

/** path 去 query:query 里可能带业务参数(产品名/关键词),埋点不许捎带。 */
function sanitizePath(path: string): string {
  return path.split("?")[0];
}

export function reportIncident(incident: FrontendIncident): void {
  const clean: FrontendIncident = { ...incident, path: sanitizePath(incident.path) };
  recent.push(clean);
  if (recent.length > MAX_KEPT) recent.shift();
  logger.error("frontend incident", { ...clean });
}

/** 测试/排查读近期埋点(生产不消费)。 */
export function recentIncidents(): FrontendIncident[] {
  return [...recent];
}

/** 测试隔离用。 */
export function __clearIncidents(): void {
  recent.length = 0;
}
